// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"78ec720b","455":"ce23c917","488":"8c21ecb5"}[chunkId] + ".chunk.js";
};